import { __assign, __awaiter, __generator } from "tslib";
import { useApiClient } from '@react/lib/api';
import { useInfiniteQuery } from 'react-query';
import { POLLING_INTERVAL_MS, queryCacheKey } from '../constants';
import { filtersToApi, formatConversation } from '../lib';
export function useConversationListQuery(filters, q) {
    var _this = this;
    var apiClient = useApiClient().portal;
    var apiFilters = filtersToApi(__assign(__assign({}, filters), { q: q }));
    return useInfiniteQuery([queryCacheKey.CONVERSATIONS, apiFilters], function (_a) {
        var pageNumber = _a.pageParam;
        return __awaiter(_this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, apiClient.fetchConversations(__assign({ pageNumber: pageNumber }, apiFilters))];
                    case 1:
                        response = _b.sent();
                        return [2 /*return*/, __assign(__assign({}, response), { data: response.data.map(formatConversation) })];
                }
            });
        });
    }, {
        getNextPageParam: function (lastPage, pages) {
            if (lastPage.data.length === 0) {
                return undefined;
            }
            return pages.length + 1;
        },
        refetchInterval: POLLING_INTERVAL_MS,
    });
}
